import * as Yup from 'yup'

export const getInitialValues = () => ({
  externalPartnerType: null,
  extensionPeriod: '',
  existingLegalEntityName: null,
  legalEntityId: null,
  legalEntityName: '',
  legalEntityCIF: '',
  legalEntityCountry: null,
  jobTitle: '',
  startDate: '',
  endDate: '',
  adAccount: false,
  googleAccount: false,
  ldapAccount: false,
  manager: null,
  delegate: null,
  store: [],
  updateComment: '',
  assignmentDetails: ''
})

export const getValidationSchema = () => {
  return Yup.object()
    .shape({
      extensionPeriod: Yup.string().when('externalPartnerType', ([externalPartnerType], schema) =>
        externalPartnerType?.label === 'Mandatar'
          ? schema.required('Extension period is required')
          : schema.nullable()
      ),
      externalPartnerType: Yup.object()
        .shape({
          label: Yup.string().required('Partner type is required'),
          value: Yup.string().required('Partner type is required')
        })
        .required('Partner type is required'),
      legalEntityName: Yup.string().required('Legal entity name is required'),
      legalEntityCIF: Yup.string().required('Legal entity CIF is required'),
      legalEntityCountry: Yup.object()
        .shape({
          label: Yup.string().required('Legal entity country is required.'),
          value: Yup.string().required('Legal entity country is required.')
        })
        .required('Legal entity country is required.'),
      jobTitle: Yup.string().required('Job Title is required'),
      startDate: Yup.date().required('Start Date is required'),
      endDate: Yup.date()
        .nullable()
        .test('is-after-start-date', 'End Date must be after Start Date', function (value) {
          const startDate = this.parent.startDate
          if (!value) return true
          if (value > startDate) return true
          return this.createError({ message: 'End Date must be after Start Date' })
        }),
      updateComment: Yup.string().nullable(),
      adAccount: Yup.boolean(),
      googleAccount: Yup.boolean(),
      ldapAccount: Yup.boolean(),
      manager: Yup.object()
        .shape({
          label: Yup.string().required('Manager is required.'),
          value: Yup.string().required('Manager is required.')
        })
        .required('Manager is required.'),
      delegate: Yup.object()
        .shape({
          label: Yup.string().nullable(),
          value: Yup.string().nullable()
        })
        .nullable(),
      store: Yup.array().when('externalPartnerType', ([externalPartnerType], schema) =>
        externalPartnerType?.label === 'Mandatar'
          ? schema.required('Store is required.')
          : schema.nullable()
      ),
      assignmentDetails: Yup.string().nullable()
    })
    .test(
      'oneOfRequired',
      'adAccount or googleAccount or ldapAccount is required',
      function (value) {
        const { adAccount, googleAccount, ldapAccount } = value
        if (!adAccount && !googleAccount && !ldapAccount) {
          return this.createError({
            path: 'googleAccount',
            message: 'AD Account or LDAP Account or Google Account is required'
          })
        }
        return true
      }
    )
    .test('storeRequired', 'Store is required', function (value) {
      const { store, externalPartnerType } = value
      if (externalPartnerType && externalPartnerType.label === 'Mandatar' && store.length === 0) {
        return this.createError({ path: 'store', message: 'Store is required' })
      }
      return true
    })
}
